/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/users-authz-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/users-authz-api-client";
import type { UsersAuthzAPIAdminPermissionsWriteDenyPermissionToGroupMutationResponse, UsersAuthzAPIAdminPermissionsWriteDenyPermissionToGroupPathParams } from "../models/UsersAuthzAPIAdminPermissionsWriteDenyPermissionToGroup";
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query";
import { usersAuthzAPIAdminPermissionsWriteDenyPermissionToGroup } from "../axios/usersAuthzAPIAdminPermissionsWriteDenyPermissionToGroup";
import { useMutation } from "@tanstack/react-query";

export const usersAuthzAPIAdminPermissionsWriteDenyPermissionToGroupMutationKey = () => ["users-authz-api", { url: '/admin/group/:groupId/permissions/:permission/deny' }] as const

export type UsersAuthzAPIAdminPermissionsWriteDenyPermissionToGroupMutationKey = ReturnType<typeof usersAuthzAPIAdminPermissionsWriteDenyPermissionToGroupMutationKey>

/**
 * @summary Deny a permission for a group
 * {@link /admin/group/:groupId/permissions/:permission/deny}
 */
export function useUsersAuthzAPIAdminPermissionsWriteDenyPermissionToGroup<TContext>(options: 
{
  mutation?: UseMutationOptions<UsersAuthzAPIAdminPermissionsWriteDenyPermissionToGroupMutationResponse, ResponseErrorConfig<Error>, {groupId: UsersAuthzAPIAdminPermissionsWriteDenyPermissionToGroupPathParams["groupId"], permission: UsersAuthzAPIAdminPermissionsWriteDenyPermissionToGroupPathParams["permission"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: typeof fetch },
}
 = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? usersAuthzAPIAdminPermissionsWriteDenyPermissionToGroupMutationKey()

  return useMutation<UsersAuthzAPIAdminPermissionsWriteDenyPermissionToGroupMutationResponse, ResponseErrorConfig<Error>, {groupId: UsersAuthzAPIAdminPermissionsWriteDenyPermissionToGroupPathParams["groupId"], permission: UsersAuthzAPIAdminPermissionsWriteDenyPermissionToGroupPathParams["permission"]}, TContext>({
    mutationFn: async({ groupId, permission }) => {
      return usersAuthzAPIAdminPermissionsWriteDenyPermissionToGroup(groupId, permission, config)
    },
    mutationKey,
    ...mutationOptions
  }, queryClient)
}